import { classNames } from "../Utils/classNames.ts";

const ROW_WIDTHS = [
  "w-full",
  "w-11/12",
  "w-full",
  "w-10/12",
  "w-full",
  "w-9/12",
];

export function LoadingRows({
  rows = 5,
  rowClassName = "h-9",
}: {
  rows?: number;
  rowClassName?: string;
}) {
  return (
    <div
      role={"status"}
      aria-label={"Loading"}
      className={"flex flex-col gap-2 animate-pulse"}
    >
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div
          key={rowIndex}
          className={classNames(
            "rounded-md bg-slate-200/70",
            rowClassName,
            ROW_WIDTHS[rowIndex % ROW_WIDTHS.length],
          )}
        />
      ))}
    </div>
  );
}

export function LoadingBlock({ sizeClassName }: { sizeClassName: string }) {
  return (
    <div
      role={"status"}
      aria-label={"Loading"}
      className={classNames(
        "rounded-md bg-slate-200/70 animate-pulse",
        sizeClassName,
      )}
    />
  );
}
